import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Login from "./components/Login";
import MainLayout from "./layout/MainLayout";
import { ProtectedRoute } from "./routes/ProtectedRoute";

import Dashboard from "./components/pages/Dashboard";
import Products from "./components/pages/Products";
import Categories from "./components/pages/Categories";
import HsnCodes from "./components/pages/HsnCodes";
import Coupons from "./components/pages/Coupons";
import Banners from "./components/pages/Banners";
import Orders from "./components/pages/Orders";
import Customers from "./components/pages/Customers";
import Analytics from "./components/pages/Analytics";
import Settings from "./components/pages/Settings";
import Inventory from "./components/pages/Inventory";
import Vendor from "./components/pages/Vendor";
import Settlements from "./components/pages/Settlements";
import CodReconciliation from "./components/pages/CodReconciliation";
import Shipping from "./components/pages/Shipping";
import Guidance from "./components/pages/Guidance";
import ParentingVideos from "./components/pages/ParentingVideos";
import Contests from "./components/pages/Contests";
import VaccinationCenters from "./components/pages/VaccinationCenters";
import VaccineSchedule from "./components/pages/VaccineSchedule";
import Notifications from "./components/pages/Notifications";
import QueueMonitor from "./components/pages/QueueMonitor";
import SubscriptionPlans from "./components/pages/SubscriptionPlans";
import VendorPlans from "./components/pages/VendorPlans";
import SalesPersons from "./components/pages/SalesPersons";
import Rewards from "./components/pages/Rewards";

export default function App() {
  return (
      <Routes>

        <Route path="/login" element={<Login />} />

        <Route
          path="/"
          element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="products" element={<Products />} />
          <Route path="categories" element={<Categories />} />
          <Route path="hsn-codes" element={<HsnCodes />} />
          <Route path="coupons" element={<Coupons />} />
          <Route path="banners" element={<Banners />} />
          <Route path="orders" element={<Orders />} />
          <Route path="shipping" element={<Shipping />} />
          <Route path="inventory" element={<Inventory />} />
          <Route path="vendor" element={<Vendor />} />
          <Route path="settlements" element={<Settlements />} />
          <Route path="cod-reconciliation" element={<CodReconciliation />} />
          <Route path="vendor-plans" element={<VendorPlans />} />
          <Route path="sales-team" element={<SalesPersons />} />
          <Route path="customers" element={<Customers />} />
          <Route path="rewards" element={<Rewards />} />
          <Route path="analytics" element={<Analytics />} />
          <Route path="guidance"              element={<Guidance />} />
          <Route path="parenting-videos"      element={<ParentingVideos />} />
          <Route path="contests"              element={<Contests />} />
          <Route path="vaccination-centers" element={<VaccinationCenters />} />
          <Route path="vaccine-schedule"   element={<VaccineSchedule />} />
          <Route path="notifications"      element={<Notifications />} />
          <Route path="queues"             element={<QueueMonitor />} />
          <Route path="subscription-plans" element={<SubscriptionPlans />} />
          <Route path="settings" element={<Settings />} />
        </Route>

      </Routes>
  );
}